import {startCase} from "lodash";
import {EditableInfo} from "../uiUtils/EditableInfo";
import React from "react";
import {DividerTitle, Label} from "../uiUtils/Helpers";
import LogoManager from "../Wizard/LogoManager";
import {Button, Divider, Radio} from "antd";
import {GatewayOutlined, MinusSquareOutlined, RollbackOutlined} from "@ant-design/icons";
import * as PropTypes from "prop-types";

export function ContentEditor(
    {
        logo, setLogo, onClickRemoveLogo, onClickPositionLogo,
        company, onChangeCompany, advertiser,
        socialMedia, setSocialMedia,
        aodAsset, disabled,
        ...props
    })
{
    const resetCompany = ()=>{
        onChangeCompany(advertiser.company);
    };

    const resetGraphics = () =>{
        setSocialMedia(true);
        onClickRemoveLogo();
    };

    return <>
        <DividerTitle>
            Text
            <Button size={'small'}
                    icon={<RollbackOutlined />} type={'link'}
                    onClick={resetCompany}
            >reset</Button>
        </DividerTitle>
        <CompanyEdit
            company={company}
            onChange={onChangeCompany}/>
        <div style={{height: 25}}/>

        <DividerTitle>
            Graphics
            <Button size={'small'}
                    icon={<RollbackOutlined />} type={'link'}
                    onClick={resetGraphics}
            >reset</Button>
        </DividerTitle>
        <LogoManager {...{logo, setLogo, advertiser}}
                     style={{marginRight: 5}}>
            {logo && logo.thumbUrl && <>
                <Button icon={<GatewayOutlined/>} onClick={onClickPositionLogo}
                        disabled={disabled}
                >{aodAsset ? "Reposition" : "Place on ad"}</Button>
                <Button icon={<MinusSquareOutlined/>} onClick={onClickRemoveLogo}
                        disabled={!aodAsset || disabled}
                >Remove from ad</Button>
                {company.name && <span style={{fontSize:'smaller', color:'gray'}}>
                    Remove the advertiser name above if you don't want it to appear in the ad with the logo.
                </span>}
            </>}
        </LogoManager>
        <Divider/>
        <Label>Social Media Icons</Label>
        <Radio.Group onChange={e => setSocialMedia(e.target.value === 'Show')}
                     value={socialMedia ? "Show" : "Hide"}
                     buttonStyle="solid" size={"small"}>
            <Radio.Button value='Show'>Show</Radio.Button>
            <Radio.Button value='Hide'>Hide</Radio.Button>
        </Radio.Group>
    </>;
}
ContentEditor.propTypes = {
    company: PropTypes.any,
    onChangeCompany: PropTypes.func,
    logo: PropTypes.shape({}),
    setLogo: PropTypes.func,
    advertiser: PropTypes.any,
    onClickPostionLogo: PropTypes.func,
    disabled: PropTypes.bool,
    aodAsset: PropTypes.any,
    onClickRemoveLogo: PropTypes.func,
    setSocialMedia: PropTypes.func,
    socialMedia: PropTypes.any
};


//todo ? general/nestedObj content editor
//todo default/reset value from advertiser
function CompanyEdit({company, onChange, ...props}) {

    const order = ['name', 'address1', 'city', 'state', 'zip', 'web', 'phone'];
    const getLabel = field => startCase(field.replace(/\d*$/, ''));

    function changeField(field, value) {
        //onChange({...company, [field]: value});
        // todo computed property problem
        const changes = {...company};
        changes[field]=value;
        onChange(changes);
    }

    const data = order.map(f => {
        return {
            label: getLabel(f),
            value: company[f],
            onChange: value => changeField(f, value),
            onClear: f==='name' ? ()=>changeField(f,'') : false
        }
    });

    return <EditableInfo data={data}/>
}